/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Context_TitleInputs */

const es_prompt_tips_context_title = /** @type {(inputs: Prompt_Tips_Context_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluí contexto para encontrar los datos`)
};

const en_prompt_tips_context_title = /** @type {(inputs: Prompt_Tips_Context_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include context to find the data`)
};

/**
* | output |
* | --- |
* | "Include context to find the data" |
*
* @param {Prompt_Tips_Context_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_context_title = /** @type {((inputs?: Prompt_Tips_Context_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Context_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_context_title(inputs)
	return en_prompt_tips_context_title(inputs)
});
export { prompt_tips_context_title as "prompt_tips.context_title" }